// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M9 1.84l6.07 3.55L22 2.5V11h-2V5.5l-4 1.67V11h-2V7.07l-4-2.33v12.19l1.87 1.09-1.01 1.72-1.93-1.13L2 21.5V5.93l7-4.09zm-1 15V4.73L4 7.07V18.5l4-1.67zm11.79-4.75l4.12 4.12-7.28 7.29H12.5v-4.13l7.29-7.28zm-.93 3.75l1.3 1.3.93-.93-1.3-1.3-.93.93zm-.11 2.7l-1.3-1.29-2.95 2.95v1.3h1.3l2.95-2.95z"}}]};

const MapEditIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-edit',
    ref,
    icon: element,
  },
));

MapEditIcon.displayName = 'MapEditIcon';

export default MapEditIcon;
